import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { AuthWrapper } from "./context/auth.context";
import { ProfileWrapper } from "./context/profile.context";
import { SnackbarProvider } from "notistack";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <BrowserRouter>
    <AuthWrapper>
      <ProfileWrapper>
        <SnackbarProvider maxSnack={3} autoHideDuration={2000}>
          <App />
        </SnackbarProvider>
      </ProfileWrapper>
    </AuthWrapper>
  </BrowserRouter>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
